import { LoadableFactory } from '®shared/data';

import {
  SectionResolverStoreActionTypes,
  SectionResolverStoreActions,
} from './section-resolver-store.actions';
import { SectionResolverStoreState } from './section-resolver-store.state';

export function sectionResolverStoreReducer(
  state: SectionResolverStoreState,
  action: SectionResolverStoreActions,
): SectionResolverStoreState {
  switch (action.type) {
    case SectionResolverStoreActionTypes.DRAFT_SECTION_REQUESTED: {
      return {
        ...state,
        draftSectionsById: state.draftSectionsById.set(
          action.payload.sectionId,
          LoadableFactory.loading(),
        ),
      };
    }
    case SectionResolverStoreActionTypes.DRAFT_SECTION_LOADED: {
      const { sectionId, section } = action.payload;
      return {
        ...state,
        draftSectionsById: state.draftSectionsById.set(
          sectionId,
          LoadableFactory.loaded(section),
        ),
      };
    }
    case SectionResolverStoreActionTypes.DRAFT_SECTION_LOADING_FAILED: {
      const { sectionId, error } = action.payload;
      return {
        ...state,
        draftSectionsById: state.draftSectionsById.set(
          sectionId,
          LoadableFactory.errored(error),
        ),
      };
    }
    case SectionResolverStoreActionTypes.PUBLISHED_SECTION_REQUESTED: {
      return {
        ...state,
        publishedSectionsById: state.publishedSectionsById.set(
          action.payload.sectionId,
          LoadableFactory.loading(),
        ),
      };
    }
    case SectionResolverStoreActionTypes.PUBLISHED_SECTION_LOADED: {
      const { sectionId, section } = action.payload;
      return {
        ...state,
        publishedSectionsById: state.publishedSectionsById.set(
          sectionId,
          LoadableFactory.loaded(section),
        ),
      };
    }
    case SectionResolverStoreActionTypes.PUBLISHED_SECTION_LOADING_FAILED: {
      const { sectionId, error } = action.payload;
      return {
        ...state,
        publishedSectionsById: state.publishedSectionsById.set(
          sectionId,
          LoadableFactory.errored(error),
        ),
      };
    }
  }

  return state;
}
